<div class="canvas-holder" [ngStyle]="{'width.px': chartSize}">
  <div class="usage" *ngIf="showUsage">
    {{ usage === 0 ? '0%' : (usage < 1 ? (usage | number:'1.2-2') : (usage | number:'1.0-0')) + '%' }}
  </div>
  <canvas 
    baseChart
    [datasets]="datasets"
    [labels]="labels"
    [legend]="false"
    [chartType]="doughnutChartType">
  </canvas>
</div>